import { useEffect } from 'react';

const useScript = (url, async = true) => {
  useEffect(() => {
    const script = document.createElement('script');

    script.src = url;
    script.async = async;
    script.type = 'text/javascript';

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [url, async]);
};

export default useScript;
